
/*
 * @Author: your name
 * @Date: 2021-12-14 10:19:35
 * @LastEditTime: 2022-01-17 15:17:48
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \lzxy-homepage\src\commons\productService.ts
 */

import { ProductDetail } from './productTreeModel'
import goodsInstance from '@/service/EnterpriseSvg'

export class ProductService {
  async getProductTree (cusType: string) {
    const res = await goodsInstance.get(`/api/v1/category/${cusType}/tree/level/two/orgId`)
    const result = res.data ? res.data : []
    // const product = result.map((item: any) => {
    //   return new ProductDetail(item.categoryId, item.pid, item.upshelfId, item.title, item.url)
    // })
    return result
  }
}
